import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISaleStatus } from "src/models/Stores/Sale.models";

interface SaleStatusState {
  salesStatus: ISaleStatus[];
  saleStatusToEdit: ISaleStatus | null;
}

const initialState: SaleStatusState = {
  salesStatus: [],
  saleStatusToEdit: null,
};

const saleSlice = createSlice({
  name: "SaleStatus",
  initialState,
  reducers: {
    setSaleStatusList: (state, action: PayloadAction<ISaleStatus[]>) => {
      state.salesStatus = action.payload;
    },
    concatListSaleStatus: (
      state: SaleStatusState,
      action: PayloadAction<ISaleStatus[]>
    ) => {
      state.salesStatus = [...state.salesStatus.concat(action.payload)];
    },
    setSaleStatusToEdit: (state, action: PayloadAction<ISaleStatus | null>) => {
      state.saleStatusToEdit = action.payload;
    },
    addSaleStatus: (state, action: PayloadAction<ISaleStatus>) => {
      state.salesStatus.push(action.payload);
    },
    updateSaleStatus: (state, action: PayloadAction<ISaleStatus>) => {
      let itemIndex = state.salesStatus.findIndex(
        item => item.saleStatusId === action.payload.saleStatusId
      );
      if (itemIndex !== -1) state.salesStatus[itemIndex] = action.payload;
    },
    deleteSaleStatus: (state, action: PayloadAction<number>) => {
      const newArray = state.salesStatus.filter(
        item => item.saleStatusId !== action.payload
      );
      state.salesStatus = newArray;
    },
  },
});

export const {
  setSaleStatusList,
  concatListSaleStatus,
  setSaleStatusToEdit,
  addSaleStatus,
  updateSaleStatus,
  deleteSaleStatus,
} = saleSlice.actions;

export default saleSlice.reducer;
